export default "__VITE_ASSET__DfQ91mgq__"